export const TASK_PROPERTY_UPDATED = 'TASK_PROPERTY_UPDATED';
export const ADD_SEQUENCE_DEPENDENCY_ALERT = 'ADD_SEQUENCE_DEPENDENCY_ALERT';